import { jsx as _jsx } from "react/jsx-runtime";
import { createToastStore } from '#pplx/frontend/aether/toasts/internal/createToastStore.js';
import { ToastStoreContext } from '#pplx/frontend/aether/toasts/internal/ToastStoreContext.js';
import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
import React, { memo, useEffect, useRef } from 'react';
const MAX_VISIBLE_TOASTS = 5;
export const ToastStoreProvider = memo(function ToastStoreProvider({ children }) {
    const storeRef = useRef(null);
    if (storeRef.current == null) {
        storeRef.current = createToastStore({
            generateId: safeRandomUUID,
            maxVisibleToasts: MAX_VISIBLE_TOASTS,
        });
    }
    const store = storeRef.current;
    useEffect(() => () => {
        store.getState().resetStore();
    }, [store]);
    return _jsx(ToastStoreContext.Provider, { value: store, children: children });
});
//# sourceMappingURL=ToastStoreProvider.js.map